import { JumplinkActions, JumplinkType } from './jumplinks.interface';
import { JumplinkActionsType } from './reducer';

export const addJumplink = (payload: JumplinkType): JumplinkActionsType => ({
  type: JumplinkActions.Add,
  payload,
});

export const clearJumplinks = (): JumplinkActionsType => ({
  type: JumplinkActions.Clear,
  payload: null,
});
